




import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import CodeEditor from '@/components/CodeEditor.vue';

@Component({
    components: {
        CodeEditor,

    },
})
export default class Sample extends Vue {

}
